import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { removeProjectModelIdsForIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';

export const useRemoveModelForIri = (iri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (item: SelectItem | null) => {
      if (!item || !diagram || !iri) {
        return;
      }
      commitDiagramModel(
        diagram,
        removeProjectModelIdsForIri(iri, [item.value])
      );
    },
    [diagram, iri]
  );
};
